import React, { Component } from 'react';
import { connect } from 'react-redux';
import createSelector from 'helpers/createSelector';
import _ from 'lodash';
import classnames from 'classnames';
import moment from 'moment';
import { updateQuery } from 'modules/router/actions';

import { DatePicker, Row, Col } from 'antd';
const RangePicker = DatePicker.RangePicker;

const container = connect(
  createSelector(
    (state) => ({
      query: _.get(state, 'router.location.query'),
      subjects: _.get(state, 'subject.entities'),
      pathname: _.get(state, 'router.location.pathname'),
    }),
    (state) => {
      const { query } = state;
      const params = state.pathname.split('/')
      const subjectId = params[2];
      const router = params[3];
      const subject = state.subjects[subjectId] || {};
      const startDate = _.isEmpty(query.startDate)
        ? router == "pooling"
          ? moment(subject.startDate)
          : moment().subtract(6, 'd').startOf('day')
        : moment(query.startDate)

      const endDate = _.isEmpty(query.endDate)
        ? router == "pooling"
          ? moment(subject.endDate)
          : moment().endOf('day')
        : moment(query.endDate)

      return ({
        startDate, endDate,
      })
    }
  )
)

class DateRangePanel extends Component {
  render() {
    const { dispatch, startDate, endDate } = this.props;
    const customLocale = {
      timezoneOffset: 8 * 60,
      firstDayOfWeek: 0,
      minimalDaysInFirstWeek: 1,
    };
    const duration = moment(endDate).diff(moment(startDate), 'days');

    return (
      <div className="query-panel-header margin-top-sm">
        <div>
          <div className="query-panel-title">{t('commonPeriod')}：</div>
          <div className="query-calendar-main">
            <div className="padding-right-md">
              <RangePicker
                showTime={{ format: 'HH:mm' }}
                format="yyyy-MM-dd HH:mm"
                locale={{ ...customLocale }}
                value={[new Date(startDate), new Date(endDate)]}
                onChange={(value) => {
                  dispatch(updateQuery({
                    startDate: value[0] == null ? '' : moment(value[0]).format('YYYY-MM-DD HH:mm:ss'),
                    endDate: value[1] == null ? '' : moment(value[1]).format('YYYY-MM-DD HH:mm:ss'),
                  }));
                }}
              />
            </div>
            <div>
              <div
                className={classnames("query-label", { active: duration === 0 })}
                onClick={() => {
                  dispatch(updateQuery({
                    startDate: moment().format('YYYY-MM-DD 00:00:00'),
                    endDate: moment().format('YYYY-MM-DD 23:59:59'),
                  }));
                }}
              >
                {t('commonToday')}
              </div>
              <div
                className={classnames("query-label", { active: duration === 6 })}
                onClick={() => {
                  dispatch(updateQuery({
                    startDate: moment().subtract(6, 'd').format('YYYY-MM-DD 00:00:00'),
                    endDate: moment().format('YYYY-MM-DD 23:59:59'),
                  }));
                }}
              >
                {t('commonPastAWeek')}
              </div>
              <div
                className={classnames("query-label", { active: duration === 30 })}
                onClick={() => {
                  dispatch(updateQuery({
                    startDate: moment().subtract(30, 'd').format('YYYY-MM-DD 00:00:00'),
                    endDate: moment().format('YYYY-MM-DD 23:59:59'),
                  }));
                }}
              >
                {t('commonPastAMonth')}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default container(DateRangePanel);



/** WEBPACK FOOTER **
 ** ./src/app/modules/controlPanel/components/DateRangePanel.js
 **/